import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _CostStudy, _NationalizationProcessGeneralInfo, _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { MakeUBLInvoice } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { SelectMonths } from "../../../../../contract/select/SelectMonths";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { PaymentMethodSelect } from "../../../../../Talentohumano/PaymentMethod/PaymentMethodSelect";
import { NationalizationProcessItemsBystudyCost } from "../NationalizationProcessItems/NationalizationProcessItemsBystudyCost";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { CurrencyEditor } from "../../../../../erp/cellEditor/Currency/CurrencyEditor";
import { SelectSiteID } from "../../../../../admin/configuracion/SiteID/SelectSiteID";
import { NationalizationProcessItemsBydescarguedirecto } from "../NationalizationProcessItems/NationalizationProcessItemsBydescarguedirecto";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const EDD001 = ({ configProcedure }: Props) => {

    const descarguedirecto = useDataBean(_NationalizationProcessGeneralInfo);

    const [invoice, setInvoice] = useState<any>({});
    const [props, setProps] = useState<any>({});
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConfAdd, setModalConfAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [idflujo, setIDflujo] = useState<number>(0);


    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])
    useEffect(() => {
        console.log("cargando de props => ", props.IDNationalizationProcessGeneralInfo);

        if (props.IDNationalizationProcessGeneralInfo) {
            descarguedirecto.instance.getNationalizationProcessGeneralInfoCatalogPorPropiedades({ IDNationalizationProcessGeneralInfo: props.IDNationalizationProcessGeneralInfo }, null).then(
                (resp: any) => {
                    if (resp.length > 0) {
                        console.log(resp[0].DataBeanProperties);
                        descarguedirecto.setBean(resp[0].DataBeanProperties);
                    }

                }
            )
        }
        else {
            descarguedirecto.setBean({
                State: 1,
                Since: _single.getCurrenDate(),
                IDEmployee: _single.getAccountID(),
                MadeByEDD: _single.getAccountID(),
            });
        }
    }, [props])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(descarguedirecto.bean.ObservationsEC)
        }

        if (configProcedure?._pushProps) {
            let x = {
                IDNationalizationProcessGeneralInfo: descarguedirecto.bean.IDNationalizationProcessGeneralInfo,
                State: 1
            }
            configProcedure?._pushProps(x)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(descarguedirecto.bean)
        }
        toast.success('Actualizado')
    }


    const create = () => {
        descarguedirecto.setBean({

            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID(),
            State: 1,

        });
        editaItem()
    }

    const createvdos = () => {
        descarguedirecto.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setTimeout(() => {
            editaItemvdos()
        }, 4000);
    }

    const editaItem = () => {


        descarguedirecto.instance.updateNationalizationProcessGeneralInfo(descarguedirecto.bean).then(
            (resp: any) => {
                onExportMap()
                console.log(resp)
                toast.success('Actualizado');
            }
        ).catch(err => {
            toast.error(err);
        })
    }


    const editaItemvdos = () => {

        console.log(descarguedirecto.bean);

        descarguedirecto.instance.updateNationalizationProcessGeneralInfo(descarguedirecto.bean).then(
            (resp: any) => {
                console.log(resp);
                toast.success('Actualizado');
                descarguedirecto.setBean(resp);
                // configProcedure._pushProps({ IDNationalizationProcessGeneralInfo: resp.IDNationalizationProcessGeneralInfo });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <div className="row">

            <div className="col-md-12">

                <strong>Descargue Directo</strong>

                <div className="row">
                    {/* <PrintJson json={costestudy.bean} /> */}
                    <div className="col-md-12">

                        <SelectAdquisitionContract idSelector={descarguedirecto.bean.IDAdquisitionContract} onChange={({ DataBeanProperties }) => { descarguedirecto.setBean({ ...descarguedirecto.bean, 'IDAdquisitionContract': DataBeanProperties.IDAdquisitionContract }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>No. Documento Transporte</label>
                        <input type="text" name="NoDocTransport" className="form-control" value={descarguedirecto.bean.NoDocTransport} onChange={descarguedirecto.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Tasa de cambio para el estudio de costos</label>
                        <input type='text' name="ExchangeRate" className="form-control" value={descarguedirecto.bean.ExchangeRate} onChange={descarguedirecto.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <CurrencyEditor id={descarguedirecto.bean.CurrencyType} onchange={(e: any) => { descarguedirecto.setBean({ ...descarguedirecto.bean, "CurrencyType": e }) }}></CurrencyEditor>
                    </div>

                    <div className="col-md-6">
                        <SelectSiteID label="Ciudad de entrega de descargue directo" edit idLnSite={descarguedirecto.bean.CityEDD} onChange={(e) => { descarguedirecto.setBean({ ...descarguedirecto.bean, "CityEDD": e.IDLn }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="DateEDD" label="Fecha de entrega de descargue directo" value={descarguedirecto.bean.DateEDD} setDate={(e: any) => { descarguedirecto.setBean({ ...descarguedirecto.bean, "DateEDD": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Profesión y Nombre de Coordinador (a) Grupo de Comercio Exterior</label>
                        <input type='text' name="CoordinationExteriorComerceEDD" className="form-control" value={descarguedirecto.bean.CoordinationExteriorComerceEDD} onChange={descarguedirecto.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Grado y nombre del Almacenista</label>
                        <input type='text' name="StorekeeperEDD" className="form-control" value={descarguedirecto.bean.StorekeeperEDD} onChange={descarguedirecto.handleChange} />
                    </div>
                </div>
                <div className="row">

                    <div className="col-md-6">
                        <BasicButton icon="ri-install-fill" clase="primary" eventClick={editaItemvdos}>Guardar Datos*</BasicButton>
                    </div>
                </div>
                {descarguedirecto.bean.IDNationalizationProcessGeneralInfo &&
                    <>
                        <div className="row">

                            <NationalizationProcessItemsBydescarguedirecto IDNationalizationProcessGeneralInfo={descarguedirecto.bean.IDNationalizationProcessGeneralInfo} />
                        </div>
                        <div className="row">
                            <div className="col-md-6">

                                <BasicButton icon="ri-inbox-unarchive-fill" clase="btn rounded-pill btn-warning waves-effect waves-light" eventClick={create}>Finalizar*</BasicButton>
                            </div>
                        </div>
                    </>
                }
            </div>
            {/* <div className="col-md-12">
                <PrintJson json={costestudy.bean} />
            </div> */}
        </div>
    )
}